<app-bottom-sheet #sheet ariaLabel="ارتباط با پشتیبانی">
	<ng-template #body>
		<ul class="flex flex-col pb-3" data-cy="menu-support-list">
			<li>
				<ui-button
					variant="ghost"
					size="lg"
					shape="square"
					class="w-full"
					extraButtonClasses="w-full gap-2 p-0! text-gray-900 hover:text-gray-900"
					data-cy="menu-support-chatbot"
					(clicked)="onChatbotClick()">
					<ui-icon
						class="shrink-0 text-gray-950"
						width="20"
						height="20"
						iconName="chatbot"
						aria-hidden="true" />
					<span class="flex h-full min-w-0 flex-1 items-center">
						<span class="min-w-0 flex-1 truncate text-right">پشتیبانی هوشمند</span>
						<ui-icon
							class="shrink-0 text-gray-500"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							iconName="chevron-left"
							aria-hidden="true" />
					</span>
				</ui-button>
			</li>
			<li>
				<a
					class="flex h-9 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
					data-cy="menu-support-call"
					[href]="phoneUrl">
					<ui-icon
						class="shrink-0 text-gray-950"
						width="20"
						height="20"
						iconName="phone"
						aria-hidden="true" />
					<span class="flex h-full min-w-0 flex-1 items-center border-t border-stroke-050">
						<span class="min-w-0 flex-1 truncate text-right">تماس با 8700</span>
						<ui-icon
							class="shrink-0 text-gray-500"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							iconName="chevron-left"
							aria-hidden="true" />
					</span>
				</a>
			</li>
		</ul>
	</ng-template>
</app-bottom-sheet>
